import { defineNuxtPlugin } from '#imports';
import authDirective from '~/directives/auth';
import loginDirective from '~/directives/login';
import trackDirective from '~/directives/track';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('auth', authDirective);
  nuxtApp.vueApp.directive('login', loginDirective);
  nuxtApp.vueApp.directive('track', trackDirective);
});
